function tryInitMap() {
  if (window.L && window.L.MarkerClusterGroup) {
    map = L.map('map', {
      scrollWheelZoom: false,
      dragging: true,
      tap: true,
    }).setView([40.0, -3.70379], 6);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 19 }).addTo(map);

    markers = L.markerClusterGroup();
    markerMap = {};

    document.querySelectorAll('.store-item').forEach(function (item, index) {
      var coord = item.querySelector('.coords');
      if (!coord) return;

      var lat = parseFloat(coord.dataset.lat);
      var lng = parseFloat(coord.dataset.lng);
      var customIcon = L.icon({
        iconUrl: window.storeLocatorSettings.customMarkerUrl || 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
        iconSize: [32, 32],
        iconAnchor: [16, 32],
        popupAnchor: [0, -32],
      });
      if (!isNaN(lat) && !isNaN(lng)) {
        var marker = L.marker([lat, lng], { icon: customIcon }).bindPopup(
          item.querySelector('.popup__text').innerHTML || ''
        );
        markers.addLayer(marker);
        markerMap[index] = marker;

        marker.on('click', function () {
          marker.openPopup();
        });
      }
    });

    map.addLayer(markers);

    document.querySelectorAll('.store-item').forEach(function (item, index) {
      item.style.cursor = 'pointer';
      item.addEventListener('click', function () {
        document.querySelectorAll('.active').forEach(function (el) {
          el.classList.remove('active');
        });
        item.classList.add('active');

        var marker = markerMap[index];
        if (marker) {
          map.setView(marker.getLatLng(), 14);
          marker.openPopup();
        }
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', function () {
  var storeLocatorData = document.getElementById('store-list');
  if (!storeLocatorData) return;

  var totalPages = parseInt(storeLocatorData.getAttribute('data-pages'));
  if (!totalPages || totalPages < 2) tryInitMap();

  var sectionElement = storeLocatorData.closest('[id^="shopify-section-"]');
  if (!sectionElement) return;
  var sectionId = sectionElement.id.replace('shopify-section-', '');

  var fetches = [];
  for (var page = 2; page <= totalPages; page++) {
    let url = `${window.location.pathname}?sections=${sectionId}&page=${page}`;
    fetches.push(
      fetch(url)
        .then((resp) => resp.json())
        .then((data) => {
          if (!data[sectionId]) return '';
          var parser = new DOMParser();
          var doc = parser.parseFromString(data[sectionId], 'text/html');
          var items = doc.querySelectorAll('.store-item');
          if (!items.length) return '';
          items.forEach(function (item) {
            storeLocatorData.appendChild(item);
          });
        })
    );
  }
  Promise.all(fetches).then(function () {
    var input = document.getElementById('store-search');
    if (input) {
      input.addEventListener('keyup', function () {
        let query = this.value.toLowerCase();
        document.querySelectorAll('.store-item').forEach(function (item) {
          let name = item.dataset.name || '';
          let address = item.dataset.address || '';
          item.style.display = name.includes(query) || address.toLowerCase().includes(query) ? '' : 'none';
        });
      });
    }

    tryInitMap();
  });
});